import MobileTitleBar from "components/MobileTitleBar"
import React, { Component, Fragment } from "react"
import { Container, Image, Button, Table,Icon , Modal} from "semantic-ui-react"
import WordPressContainer from "WordPressContainer"
import shop from "shop/shop"
import Responsive from "react-responsive"
import Slider from "components/Slider/Slider"
import ProductCard     from "components/Product/ProductCard"
import _            from "lodash"
import productStore from "stores/productStore"
import categoryStore from "stores/categoryStore"
import cmsStore from "stores/cmsStore"
import settingStore from "stores/settingStore"
import queryString                                                                                   from "qs"
import { observer }                                              from "mobx-react"
import ProductList                                                                    from "components/Product/ProductList"
import "style/HomePageV2.scss"
import CategoryShortcuts                                                                             from "plugin/CategoryShortcuts/CategoryShortcuts"
import CategorySlider                                                                             from "plugin/CategoryShortcuts/CategorySlider"
import SliderHomePage from "../components/Slider/SilderHomePage"
import { Link, NavLink }                                         from "react-router-dom"
import NewCustomerContactPage from "./NewCustomerContactPage"
import HeroSection from "../components/Slider/HeroSection"
import languageStore               from "stores/languageStore"

@observer
export default class HomePageV2 extends Component {

    state = {
        loading: false,
        products: [],
        productsForList:[],
        categoryIdforCards: settingStore.get("orderMode") === "laboratory" ? "40" : "49",
        orderModeState: settingStore.get("orderMode"),
        customerRegister: false,
        showNewsLetterConsent: localStorage.getItem("newsLetterCheckup") === "true" ? true : false,
    }
    async componentDidMount() {
        await this.load(this.props, "medicine");
        await this.load(this.props, "laboratory");
        //localStorage.setItem("newsLetterCheckup", "false");
    }


    async loadCategoriesForCards() {

    }

    load = async ( props = this.props, orderMode ) => {
        let lastFilter = false
        this.setState( { loading: true } )
        const query = queryString.parse( props.location.search.substr( 1 ) )
        const { categories = "" } = props.match.params
        const parentCategories = categories.split( "/" )
        const categoryId = parentCategories.pop()
        const category = categoryStore.categoriesById.get( orderMode === "laboratory" ? 40 : 49)
        
        // TODO: NOT EVERY CATEGORY STORE SUPPORTS THIS 
        // categoryStore.fetchCategoryMeta && categoryStore.fetchCategoryMeta( categoryId )
        
        const { page = 1, count = shop.config.standards.ITEMS_PER_PAGE } = query
        let filters = []
        const fields = _.pick( query, shop.config.pickFilter )
        const filterSize = _.size( fields )
        
        _.forEach( fields, ( value, key ) => {
          
          // MULTIFILTERS ARE ADDED AS "OR"
          if ( Array.isArray( value ) ) {
            let queryFilters = value.map( v => {
              return {
                op: "equals", extra: true, field: key, value: v
              }
            } )
            
            let combinedFilter = { "or": queryFilters }
            filters.push( combinedFilter )
            
          } else {
            let filter = {
              op: "equals", extra: true, field: key, value: value
            }
            filters.push( filter )
          }
        } )
        
        // Only hide variants if we don't search by filter
        // i.e. user searches for color only available on variants
        if ( cmsStore.config.plugin.hideVariants ) {
          // FILTER ALL VARIANTS (ONLY MAIN-ARTCILES)
          let noVariants = {
            op: "equals", field: "type", value: "1"
          }
          const singleItems = { "field": "mainArticle", "op": "equals", "value": "" } //CollectionPage mainArticle = mainart
          let combinedFilter = [{ "or": [singleItems, noVariants] }]
          filters = filters.concat( combinedFilter ) // this shows only mainarticles (i.e. no-variants))
        }
        
        
        if ( categoryId ) {
          this.fetchCategoryPage( categoryId )
          
          productStore.fromCategory( categoryId, {
            value: "%%",
            dir: query.dir || shop.config.standards.DIR || "des",
            sort: query.sort || shop.config.standards.SORT || "sort",
            page,
            count: count || shop.config.standards.ITEMS_PER_PAGE,
          }, filters ).then( res => {
            if ( !res.products.length ) {
              
              let catQuery = {
                value: "%%",
                dir: query.dir || shop.config.standards.DIR || "des",
                sort: query.sort || shop.config.standards.SORT || "sort",
                page,
                count: count || shop.config.standards.ITEMS_PER_PAGE,
              }
              
              let additionalFilters = filters.filter( e => e.field !== "type" )
              
              // console.info( "NO VARIANTS FOUND - FALLBACK TO 'SHOW ALL'" )
              return productStore.fromCategory( categoryId, catQuery, additionalFilters )
                                 .then( res => {
                                   let { products } = res
                                   if ( products.length === 0 ) {
                                     if ( products.length === 0 && shop.config.collections.showProductsFromSubCategories ) {
                                       // get products from all child categories
                    
                                       const mapChildren = cat => {
                                         if ( cat.children.length > 0 ) return _.map( cat.children, mapChildren )
                                         return cat.map_id
                                       }
                    
                                       const ids = _.flatten( category && category.children.map( mapChildren ) )
                                       if ( ids.length > 0 ) {
                                         return productStore.fromCategory( ids, catQuery, additionalFilters )
                                       }
                                     }
                                   }
                                   return res
                                 } )
            }
            return res
          } )
                      .then( res => {
                        let { products, meta = {}, fields, size } = res
                        fields = fields || meta.fields
                       // console.log( "NEW FILTER FIELDS", categoryId, Object.keys( fields ).length, { fields } )
                        this.setState( { products, category, fields, size, meta, filterCount: fields && fields.length, loading: false } )
                        return res
                      } )
        } else {
          productStore.query( {
                                value: "%%",
                                filter: [...filters],
                                dir: query.dir || shop.config.filter_defaults.sort || "des",
                                sort: query.sort || shop.config.filter_defaults.sort,
                                page,
                                count: count || shop.config.standards.ITEMS_PER_PAGE,
                              } )
                      .then( res => {
                        lastFilter = this.props.location.search
                        let { products, size } = res
                        this.setState( { products, size, filterCount: fields && fields.length, loading: false } )
                      } )
        }
      }

    render() {
        //console.log("shop", shop)
        const { products, loading, category, fields, size, categoryIdforCards, orderModeState, customerRegister, showNewsLetterConsent } = this.state
        //console.log("products", products, loading, category, fields, size)
        //const productsForList = products.map(product => product.map_id);
        const productsForList = ["100015","100014","100013","100012","100011","100016","100017","100018",];
        const { currentLanguage } = languageStore
        console.log("showNewsLetterConsent", showNewsLetterConsent)
        const orderMode = orderModeState
        const categoryforCards1 = [];
        categoryStore.categories.forEach(category => {
            if (!categoryforCards1.children) {
          categoryforCards1.children = [];
            }
            categoryforCards1.children.push(category);
        });
        //const categoryforCardsLaboratory = categoryStore.categoriesById.get( "Outdoorvasen" )
        console.log("CAT", categoryforCards1)
        return (
            <div > {/*style={{ width: "100vw", overflow: "hidden" }} */}
                    {/*Newsletter Banner */}
        {!showNewsLetterConsent && shop.session && <Fragment>
           <div className="backgroundNewsLetter"
                  style={{
            display: "block",
            position: "fixed",
            bottom: "0%",
            left: "0%",
            width: "100%",
            height: "100%",
            zIndex: 5000,
            background: "rgba(54, 150, 120, 0.4)", // opacity 0.4
            border: "1px solid #ccc",
          }}
        ><div className=" ">
          <Responsive minWidth={900}>
          <div
          className="newsletter-consent-banner"
          style={{
            display: "block",
            position: "fixed",
            bottom: "30%",
            left: "50%",
            transform: "translateX(-50%)",
            zIndex: 5001,
            background: "white",
            border: "1px solid #ccc",
            boxShadow: "0 0 10px rgba(0,0,0,0.1)",
            maxWidth: "1050px",
            minWidth: "900px",
            minHeight: "350px",
            maxHeight: "350px",
            textAlign: "left",
            backgroundColor: "#F8F7EC",
            animation: "fadeIn 0.5s",
          }}
        ><div className="pa">
             {console.log("newsletter", showNewsLetterConsent)}
            <div className="relative">
              <div className="absolute top-1 right-1">
                <button onClick={() => { localStorage.setItem("newsLetterCheckup", "true"); this.setState({ showNewsLetterConsent: localStorage.getItem("newsLetterCheckup") }) }} style={{ height: "35px", width: "40px", border: "0px solid black", backgroundColor: "#346E5B", }}><Icon className="pl1 white close"></Icon></button>
              </div>
              <div style={{ position: "fixed", bottom: "45%", right: "5%", }}><Link to={"/account/?referer=_newsletter"}><Button onClick={() => { localStorage.setItem("newsLetterCheckup", "true"); this.setState({ showNewsLetterConsent: false }) }}
                style={{ minWidth: "280px", height: "50px", borderRadius: "35px" }} primary>{translate("Newsletter Anmeldung absenden")}</Button></Link></div>
              <div className="pa5">
              <p className="black-40 fw6 f4">{translate("Newsletter Anmeldung")}</p>
              <p className="f2 fw6"><div><span >{translate("Neues entdecken.")}</span></div>
              <div><span >{translate("Informiert bleiben.")}</span></div></p>
              <p className="fw5">{translate("Immer einen Schritt voraus – mit unseren Produktnews:")}</p>
              <div className="flex flex-row justify-start pt3">
                <div style={{background: "#C9EADF", borderRadius: "35px", width: "140px", height: "30px", marginRight: "5px"}}><p style={{color: "#346E5B", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", height: "100%" }} className="fw6">{translate("neue Produkte")}</p></div>
                <div style={{background: "#C9EADF", borderRadius: "35px", width: "160px", height: "30px", marginRight: "5px"}}><p style={{color: "#346E5B", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", height: "100%" }} className="fw6">{translate("Produkthighlights")}</p></div>
                <div style={{background: "#C9EADF", borderRadius: "35px", minWidth: "180px", height: "30px", marginRight: "5px"}}><p style={{color: "#346E5B", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", height: "100%" }} className="fw6">{translate("Unternehmens-News")}</p></div>
                <div style={{background: "#C9EADF", borderRadius: "35px", width: "120px", height: "30px", marginRight: "5px"}}><p style={{color: "#346E5B", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", height: "100%" }} className="fw6">{translate("Aktionen")}</p></div>
              </div></div>
            </div></div>
          </div></Responsive>
          <Responsive maxWidth={899}>
                      <div
          className="newsletter-consent-banner"
          style={{
            display: "block",
            position: "fixed",
            bottom: "30%",
            left: "50%",
            transform: "translateX(-50%)",
            zIndex: 5001,
            background: "white",
            border: "1px solid #ccc",
            boxShadow: "0 0 10px rgba(0,0,0,0.1)",
            maxWidth: "400px",
            minWidth: "400px",
            minHeight: "450px",
            maxHeight: "450px",
            textAlign: "left",
            backgroundColor: "#F8F7EC",
            animation: "fadeIn 0.5s",
          }}
        ><div className="pa">
             {console.log("newsletter", showNewsLetterConsent)}
            <div className="relative">
              <div className="absolute top-1 right-1">
                <button onClick={() => { localStorage.setItem("newsLetterCheckup", "true"); this.setState({ showNewsLetterConsent: localStorage.getItem("newsLetterCheckup") }) }} style={{ height: "35px", width: "40px", border: "0px solid black", backgroundColor: "#346E5B", }}><Icon className="white close"></Icon></button>
              </div>
              
              <div className="pa5 tc">
              <p className="black-40 fw6 f4">{translate("Newsletter Anmeldung")}</p>
              <p className="f3 fw7"><div><span >{translate("Neues entdecken.")}</span></div>
              <div><span >{translate("Informiert bleiben.")}</span></div></p>
              <p className="fw5 f4">{translate("Immer einen Schritt voraus - mit unseren Produktnews")}:</p>
              <div className="flex flex-row justify-center pt3">
                <div style={{background: "#C9EADF", borderRadius: "35px", width: "140px", height: "30px", marginRight: "5px"}}><p style={{color: "#346E5B", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", height: "100%" }} className="fw6">{translate("neue Produkte")}</p></div>
                <div style={{background: "#C9EADF", borderRadius: "35px", width: "160px", height: "30px", marginRight: "5px"}}><p style={{color: "#346E5B", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", height: "100%" }} className="fw6">{translate("Produkthighlights")}</p></div>
              </div>
              <div className="flex flex-row justify-center pt3 pb4">
                <div style={{background: "#C9EADF", borderRadius: "35px", minWidth: "180px", height: "30px", marginRight: "5px"}}><p style={{color: "#346E5B", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", height: "100%" }} className="fw6">{translate("Unternehmens-News")}</p></div>
                <div style={{background: "#C9EADF", borderRadius: "35px", width: "120px", height: "30px", marginRight: "5px"}}><p style={{color: "#346E5B", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", height: "100%" }} className="fw6">{translate("Aktionen")}</p></div>
              </div>
              <Link to={"/account/?referer=_newsletter"}><Button onClick={() => { localStorage.setItem("newsLetterCheckup", "true"); this.setState({ showNewsLetterConsent: false }) }}
                style={{ minWidth: "280px", height: "50px", borderRadius: "35px" }} primary>{translate("Newsletter Anmeldung absenden")}</Button></Link>
                </div>
            </div></div>
          </div>
            </Responsive>
            </div>
            </div></Fragment>}

           <HeroSection props={this.props} />

             {/* <SliderHomePage  props={this.props}/> */}
            
            <section className="container pb4 pt5 bb b--black-10">
            <Responsive minWidth={1200}>
              <table>
              <colgroup>
              <col style={{ width: "25%" }} />
              <col style={{ width: "25%" }} />
              <col style={{ width: "25%" }} />
              <col style={{ width: "25%" }} />
              </colgroup>
              <tbody>
              <tr>
                <td className="fw6 f4">
                  <div className="tc">
                <div className="tc pa2 pb3">{translate("Jetzt kostenlos registrieren")}</div>
                <Button
                  style={{ minWidth: "280px", height: "50px", borderRadius: "35px" }}
                  as={Link}
                  to={`/login/?referrer=${document.location.pathname}register`}
                  primary
                  target="_blank"
                  rel="noopener noreferrer"
                ><p className="tc" style={{ margin: 0, display: "flex", alignItems: "center", height: "100%", justifyContent: "center" }}>
                  <Icon name={"large white file text"}/>{translate( "Neukunde" )}
                </p>
                 
                </Button></div>
                <div className="tc pt4">
                <div className="tc pa2 pb3">{translate("BestandskundeFrage")}</div>
                <Button
                  style={{ minWidth: "280px", height: "50px", borderRadius: "35px" }}
                  onClick={() => this.setState({ customerRegister: true })}
                  primary
                ><p className="tc" style={{ margin: 0, display: "flex", alignItems: "center", height: "100%", justifyContent: "center" }}>
                  <Icon name={"large white file text"}/>{translate( "Zugang anfordern" )}</p>
                </Button></div>
               <Modal style={{ borderRadius: 20,}} className="ModalLoginPage"  open={customerRegister} onClose={() => this.setState({ customerRegister: false})}>
							<Modal.Header>
							<div className="flex flex-row justify-between items-center">
								<div>{translate( "Zugang anfordern" )}</div>
								<Button basic circular
										onClick={() => {
										this.setState({ customerRegister: false})
										}}
										icon="times"
								/>
							</div>
							
							</Modal.Header>
							<Modal.Content>
										<NewCustomerContactPage closeModal={true} onCloseModal={() => this.setState({ customerRegister: false })} />
							</Modal.Content>
						</Modal>
                </td>
                <td className="relative pa3"  >
                  <div style={{ textAlign: "center", backgroundColor: "#f3f0e7", minHeight: "250px", borderRadius: "35px", borderTopLeftRadius: "0px" }}>
                  <table>
                    <tbody>
                      <tr>
                        <td style={{ textAlign: "center" }} className="pt4">
                        <svg xmlns="http://www.w3.org/2000/svg" width="61" height="60" viewBox="0 0 61 60" fill="none">
                          <g clipPath="url(#clip0_104_7466)">
                          <path d="M21.5 31.5C9.8 31.5 0.5 40.8 0.5 52.5V55.5H42.5V52.5C42.5 40.8 33.2 31.5 21.5 31.5ZM6.8 49.5C8.3 42.6 14.3 37.5 21.5 37.5C28.7 37.5 34.7 42.6 36.2 49.5H6.8Z" fill="#a2cf66"/>
                          <path d="M21.5 28.5C28.1 28.5 33.5 23.1 33.5 16.5C33.5 9.9 28.1 4.5 21.5 4.5C14.9 4.5 9.5 9.9 9.5 16.5C9.5 23.1 14.9 28.5 21.5 28.5ZM21.5 10.5C24.8 10.5 27.5 13.2 27.5 16.5C27.5 19.8 24.8 22.5 21.5 22.5C18.2 22.5 15.5 19.8 15.5 16.5C15.5 13.2 18.2 10.5 21.5 10.5Z" fill="#a2cf66"/>
                          <path d="M56.2999 18L46.3999 27.9L41.5999 23.4L37.3999 27.6L46.3999 36.6L60.4999 22.2L56.2999 18Z" fill="#a2cf66"/>
                          </g>
                          <defs>
                          <clipPath id="clip0_104_7466">
                          <rect width="60" height="60" fill="white" transform="translate(0.5)"/>
                          </clipPath>
                          </defs>
                          </svg>
                        </td>
                      </tr>
                      <tr>
                        <td  style={{ textAlign: "center"}} className="pa2 pt3 f4 fw7"> {translate("Online Registrieren")}</td>
                      </tr>
                      <tr>
                        <td  style={{ textAlign: "center" }} className="pa2 pt3 f5 fw5" >{translate("Erstellen Sie Ihr Kundenkonto in nur wenigen Minuten.")} </td>
                      </tr>
                    </tbody>
                  </table>
                  </div>
                <div
              style={{
              position: "absolute",
              top: "0",
              left: "0",
              backgroundColor: "#a2cf66",
              color: "white",
              padding: "5px 12px",
              borderRadius: "50px",
              fontSize: "1rem",
              }}
              >
              1
              </div>
                </td>
                <td className="relative pa3">
                <div style={{ textAlign: "center", backgroundColor: "#f3f0e7", minHeight: "250px" , borderRadius: "35px", borderTopLeftRadius: "0px" }}>
                  <table>
                    <tbody>
                      <tr>
                        <td style={{ textAlign: "center" }} className="pt4">
                        <svg xmlns="http://www.w3.org/2000/svg" width="61" height="60" viewBox="0 0 61 60" fill="none">
                          <g clipPath="url(#clip0_104_7466)">
                          <path d="M21.5 31.5C9.8 31.5 0.5 40.8 0.5 52.5V55.5H42.5V52.5C42.5 40.8 33.2 31.5 21.5 31.5ZM6.8 49.5C8.3 42.6 14.3 37.5 21.5 37.5C28.7 37.5 34.7 42.6 36.2 49.5H6.8Z" fill="#a2cf66"/>
                          <path d="M21.5 28.5C28.1 28.5 33.5 23.1 33.5 16.5C33.5 9.9 28.1 4.5 21.5 4.5C14.9 4.5 9.5 9.9 9.5 16.5C9.5 23.1 14.9 28.5 21.5 28.5ZM21.5 10.5C24.8 10.5 27.5 13.2 27.5 16.5C27.5 19.8 24.8 22.5 21.5 22.5C18.2 22.5 15.5 19.8 15.5 16.5C15.5 13.2 18.2 10.5 21.5 10.5Z" fill="#a2cf66"/>
                          <path d="M56.2999 18L46.3999 27.9L41.5999 23.4L37.3999 27.6L46.3999 36.6L60.4999 22.2L56.2999 18Z" fill="#a2cf66"/>
                          </g>
                          <defs>
                          <clipPath id="clip0_104_7466">
                          <rect width="60" height="60" fill="white" transform="translate(0.5)"/>
                          </clipPath>
                          </defs>
                          </svg>
                        </td>
                      </tr>
                      <tr>
                        <td  style={{ textAlign: "center"}} className="pa2 pt3 f4 fw7"> {translate("Stöbern & Bestellen")}</td>
                      </tr>
                      <tr>
                        <td  style={{ textAlign: "center" }} className="pa2 pt3 f5 fw5" >{translate("PostRegisterHint")} </td>
                      </tr>
                    </tbody>
                  </table>
                  </div>
                <div
              style={{
              position: "absolute",
              top: "0",
              left: "0",
              backgroundColor: "#a2cf66",
              color: "white",
              padding: "5px 12px",
              borderRadius: "50px",
              fontSize: "1rem",
              }}
              >
              2
              </div>
                </td>
                  <td className="relative pa3">
                  
                  <div style={{ textAlign: "center", backgroundColor: "#f3f0e7", minHeight: "250px" , borderRadius: "35px", borderTopLeftRadius: "0px" }}>
                  <table>
                    <tbody>
                      <tr>
                        <td style={{ textAlign: "center" }} className="pt4">
                        <svg xmlns="http://www.w3.org/2000/svg" width="61" height="60" viewBox="0 0 61 60" fill="none">
                          <g clipPath="url(#clip0_104_7466)">
                          <path d="M21.5 31.5C9.8 31.5 0.5 40.8 0.5 52.5V55.5H42.5V52.5C42.5 40.8 33.2 31.5 21.5 31.5ZM6.8 49.5C8.3 42.6 14.3 37.5 21.5 37.5C28.7 37.5 34.7 42.6 36.2 49.5H6.8Z" fill="#a2cf66"/>
                          <path d="M21.5 28.5C28.1 28.5 33.5 23.1 33.5 16.5C33.5 9.9 28.1 4.5 21.5 4.5C14.9 4.5 9.5 9.9 9.5 16.5C9.5 23.1 14.9 28.5 21.5 28.5ZM21.5 10.5C24.8 10.5 27.5 13.2 27.5 16.5C27.5 19.8 24.8 22.5 21.5 22.5C18.2 22.5 15.5 19.8 15.5 16.5C15.5 13.2 18.2 10.5 21.5 10.5Z" fill="#a2cf66"/>
                          <path d="M56.2999 18L46.3999 27.9L41.5999 23.4L37.3999 27.6L46.3999 36.6L60.4999 22.2L56.2999 18Z" fill="#a2cf66"/>
                          </g>
                          <defs>
                          <clipPath id="clip0_104_7466">
                          <rect width="60" height="60" fill="white" transform="translate(0.5)"/>
                          </clipPath>
                          </defs>
                          </svg>
                        </td>
                      </tr>
                      <tr>
                        <td  style={{ textAlign: "center"}} className="pa2 pt3 f4 fw7"> {translate("Schnelle Lieferung")}</td>
                      </tr>
                      <tr>
                        <td  style={{ textAlign: "center" }} className="pa2 pt3 f5 fw5" >{translate("FastDeliveryHint")} </td>
                      </tr>
                    </tbody>
                  </table>
                  </div>
                  <div
                style={{
                position: "absolute",
                top: "0",
                left: "0",
                backgroundColor: "#a2cf66",
                color: "white",
                padding: "5px 12px",
                borderRadius: "50px",
                fontSize: "1rem",
                }}
                >
                3
                </div>
                  </td>
              </tr>
              </tbody>
            </table>
              </Responsive>

              <Responsive maxWidth={1199}>
                <div className="flex flex-column items-center">
                <table style={{ backgroundColor: "transparent", border: "none"}}>
                  <tbody>
                    <tr>
                      <td className="fw7 f3 tc"  style={{ textAlign: "center" }}>

                                          <div className="tc">
                <div className="tc pa2 pb3">{translate("Jetzt kostenlos registrieren")}</div>
                <Button
                  style={{ minWidth: "280px", height: "50px", borderRadius: "35px" }}
                  as={Link}
                  to={`/login/?referrer=${document.location.pathname}register`}
                  primary
                  target="_blank"
                  rel="noopener noreferrer"
                ><p className="tc" style={{ margin: 0, display: "flex", alignItems: "center", height: "100%", justifyContent: "center" }}>
                  <Icon name={"large white file text"}/>{translate( "Neukunde" )}
                </p>
                 
                </Button></div>
                      </td>
                      </tr>
                      <tr>
                      <td className="fw7 f3 tc"  style={{ textAlign: "center" }}>
                        <div className="tc pt4">
                          <div className="tc pa2 pb3">{translate("BestandskundeFrage")}</div>
                          <Button
                            style={{ minWidth: "280px", height: "50px", borderRadius: "35px", padding: "10px 20px 10px 20px", }}
                            onClick={() => this.setState({ customerRegister: true })}
                            primary
                          ><p className="tc" style={{ margin: 0, display: "flex", alignItems: "center", height: "100%", justifyContent: "center" }}>
                            <Icon name={"large white file text"}/>{translate( "Zugang anfordern" )}</p>
                          </Button></div>
                        <Modal style={{ borderRadius: 20,}} className="ModalLoginPage"  open={customerRegister} onClose={() => this.setState({ customerRegister: false})}>
                        <Modal.Header>
                        <div className="ml3 flex flex-row justify-between items-center">
                          <div>{translate( "Zugang anfordern" )}</div>
                          <Button basic circular
                              onClick={() => {
                              this.setState({ customerRegister: false})
                              }}
                              icon="times"
                          />
                        </div>
                        
                        </Modal.Header>
                        <Modal.Content>
                              <NewCustomerContactPage closeModal={true} onCloseModal={() => this.setState({ customerRegister: false })} />
                        </Modal.Content>
                      </Modal>
                      </td>
                      </tr>
                      {/*                    <tr>
                    <td className="relative pa3 tc"  style={{ textAlign: "center" }}>
                    <div className={"w-100 flex flex-row items-center justify-center"}>
                    <div style={{ textAlign: "center", backgroundColor: " #f3f0e7", minHeight: "250px" }}>
                  <table >
                    <tbody>
                      <tr style={{ textAlign: "center", border:"none" }}>
                        <td style={{ textAlign: "center", border: "2px solid #f3f0e7",  }} className="pt4">
                        <svg xmlns="http://www.w3.org/2000/svg" width="61" height="60" viewBox="0 0 61 60" fill="none">
                          <g clipPath="url(#clip0_104_7466)">
                          <path d="M21.5 31.5C9.8 31.5 0.5 40.8 0.5 52.5V55.5H42.5V52.5C42.5 40.8 33.2 31.5 21.5 31.5ZM6.8 49.5C8.3 42.6 14.3 37.5 21.5 37.5C28.7 37.5 34.7 42.6 36.2 49.5H6.8Z" fill="#a2cf66"/>
                          <path d="M21.5 28.5C28.1 28.5 33.5 23.1 33.5 16.5C33.5 9.9 28.1 4.5 21.5 4.5C14.9 4.5 9.5 9.9 9.5 16.5C9.5 23.1 14.9 28.5 21.5 28.5ZM21.5 10.5C24.8 10.5 27.5 13.2 27.5 16.5C27.5 19.8 24.8 22.5 21.5 22.5C18.2 22.5 15.5 19.8 15.5 16.5C15.5 13.2 18.2 10.5 21.5 10.5Z" fill="#a2cf66"/>
                          <path d="M56.2999 18L46.3999 27.9L41.5999 23.4L37.3999 27.6L46.3999 36.6L60.4999 22.2L56.2999 18Z" fill="#a2cf66"/>
                          </g>
                          <defs>
                          <clipPath id="clip0_104_7466">
                          <rect width="60" height="60" fill="white" transform="translate(0.5)"/>
                          </clipPath>
                          </defs>
                          </svg>
                        </td>
                      </tr>
                      <tr>
                        <td  style={{ textAlign: "center",  border: "2px solid #f3f0e7",  }} className="pa2 pt3 f4 fw7"> {translate("Online Registrieren")}</td>
                      </tr>
                      <tr>
                        <td  style={{ textAlign: "center",  border: "2px solid #f3f0e7",  }} className="pa2 pt3 f5 fw5" >{translate("Erstellen Sie Ihr Kundenkonto in nur wenigen Minuten.")} </td>
                      </tr>
                    </tbody>
                  </table>
                  </div>
                        </div>
                        </td>
                    </tr>
                    <tr>
                    <td className="relative pa3 tc"  style={{ textAlign: "center" }}>
                    <div className={"w-100 flex flex-row items-center justify-center"}>
                    <div style={{ textAlign: "center", backgroundColor: " #f3f0e7", minHeight: "250px" }}>
                  <table >
                    <tbody>
                      <tr style={{ textAlign: "center", }}>
                        <td style={{ textAlign: "center", border: "2px solid #f3f0e7",  }} className="pt4">
                        <svg xmlns="http://www.w3.org/2000/svg" width="61" height="60" viewBox="0 0 61 60" fill="none">
                          <g clipPath="url(#clip0_104_7466)">
                          <path d="M21.5 31.5C9.8 31.5 0.5 40.8 0.5 52.5V55.5H42.5V52.5C42.5 40.8 33.2 31.5 21.5 31.5ZM6.8 49.5C8.3 42.6 14.3 37.5 21.5 37.5C28.7 37.5 34.7 42.6 36.2 49.5H6.8Z" fill="#a2cf66"/>
                          <path d="M21.5 28.5C28.1 28.5 33.5 23.1 33.5 16.5C33.5 9.9 28.1 4.5 21.5 4.5C14.9 4.5 9.5 9.9 9.5 16.5C9.5 23.1 14.9 28.5 21.5 28.5ZM21.5 10.5C24.8 10.5 27.5 13.2 27.5 16.5C27.5 19.8 24.8 22.5 21.5 22.5C18.2 22.5 15.5 19.8 15.5 16.5C15.5 13.2 18.2 10.5 21.5 10.5Z" fill="#a2cf66"/>
                          <path d="M56.2999 18L46.3999 27.9L41.5999 23.4L37.3999 27.6L46.3999 36.6L60.4999 22.2L56.2999 18Z" fill="#a2cf66"/>
                          </g>
                          <defs>
                          <clipPath id="clip0_104_7466">
                          <rect width="60" height="60" fill="white" transform="translate(0.5)"/>
                          </clipPath>
                          </defs>
                          </svg>
                        </td>
                      </tr>
                      <tr>
                        <td  style={{ textAlign: "center",  border: "2px solid #f3f0e7",  }} className="pa2 pt3 f4 fw7"> {translate("Stöbern & Bestellen")}</td>
                      </tr>
                      <tr>
                        <td  style={{ textAlign: "center",  border: "2px solid #f3f0e7",  }} className="pa2 pt3 f5 fw5" >{translate("Nach kurzer Prüfung wird Ihr Konto freigeschaltet –")}<br/> {translate("entdecken Sie unser gesamtes Sortiment")}<br/> {translate("zu Ihren Konditionen.")} </td>
                      </tr>
                    </tbody>
                  </table>
                  </div>
                        </div>
                        </td>
                    </tr>
                    <tr>
                    <td className="relative pa3 tc"  style={{ textAlign: "center" }}>
                    <div className={"w-100 flex flex-row items-center justify-center"}>
                    <div style={{ textAlign: "center", backgroundColor: " #f3f0e7", minHeight: "250px" }}>
                  <table >
                    <tbody>
                      <tr style={{ textAlign: "center", }}>
                        <td style={{ textAlign: "center", border: "2px solid #f3f0e7",  }} className="pt4">
                        <svg xmlns="http://www.w3.org/2000/svg" width="61" height="60" viewBox="0 0 61 60" fill="none">
                          <g clipPath="url(#clip0_104_7466)">
                          <path d="M21.5 31.5C9.8 31.5 0.5 40.8 0.5 52.5V55.5H42.5V52.5C42.5 40.8 33.2 31.5 21.5 31.5ZM6.8 49.5C8.3 42.6 14.3 37.5 21.5 37.5C28.7 37.5 34.7 42.6 36.2 49.5H6.8Z" fill="#a2cf66"/>
                          <path d="M21.5 28.5C28.1 28.5 33.5 23.1 33.5 16.5C33.5 9.9 28.1 4.5 21.5 4.5C14.9 4.5 9.5 9.9 9.5 16.5C9.5 23.1 14.9 28.5 21.5 28.5ZM21.5 10.5C24.8 10.5 27.5 13.2 27.5 16.5C27.5 19.8 24.8 22.5 21.5 22.5C18.2 22.5 15.5 19.8 15.5 16.5C15.5 13.2 18.2 10.5 21.5 10.5Z" fill="#a2cf66"/>
                          <path d="M56.2999 18L46.3999 27.9L41.5999 23.4L37.3999 27.6L46.3999 36.6L60.4999 22.2L56.2999 18Z" fill="#a2cf66"/>
                          </g>
                          <defs>
                          <clipPath id="clip0_104_7466">
                          <rect width="60" height="60" fill="white" transform="translate(0.5)"/>
                          </clipPath>
                          </defs>
                          </svg>
                        </td>
                      </tr>
                      <tr>
                        <td  style={{ textAlign: "center",  border: "2px solid #f3f0e7",  }} className="pa2 pt3 f4 fw7"> {translate("Schnelle Lieferung")}</td>
                      </tr>
                      <tr>
                        <td  style={{ textAlign: "center",  border: "2px solid #f3f0e7",  }} className="pa2 pt3 f5 fw5" >{translate("Einfach online bestellen und Ihre Ware rasch erhalten.")} </td>
                      </tr>
                    </tbody>
                  </table>
                  </div>
                        </div>
                        </td>
                    </tr> */}
                  </tbody>
                </table>
                </div>
              </Responsive>
            </section>
            {/*<section className="container pb5 pt2">
              <Responsive minWidth={768}>
                <div className="flex flex-row items-center justify-center">
                <div className="flex flex-row items-center justify-center pr2 black-60 fw6 f4"><Image src="/image/fi_4947265.svg" className="pa3" style={{ filter: "brightness(95%)" }} /> {translate("Versandkostenfrei ab 250€")} </div>
                <div className="flex flex-row items-center justify-center pl2 pr2 black-60 fw6 f4"><Image src="/image/fi_7491804.svg" className="pa3" style={{ filter: "brightness(95%)" }} />{translate("Schnelle Lieferung")}</div>
                <div className="flex flex-row items-center justify-center pl2 black-60 fw6 f4"><Image src="/image/fi_4947209.svg" className="pa3" style={{ filter: "brightness(95%)" }} />{translate("Exklusive Rabatte möglich")}</div>
                </div>
              </Responsive>
              <Responsive maxWidth={767}>
                <Table style={{ backgroundColor: "transparent", border: "none"}}>
                  <tbody>
                    <tr>
                      <div className={"w-100 flex flex-row items-center justify-center"}>
                      <div className="flex flex-row items-center justify-center black-60 fw6 f4"><Image src="/image/fi_4947265.svg" className="pa3" style={{ filter: "brightness(95%)" }} /> {translate("Versandkostenfrei ab 250€")} </div>
                      </div>
                    </tr>
                    <tr>
                      <div className={"w-100 flex flex-row items-center justify-center"}>
                      <div className="flex flex-row items-center justify-center black-60 fw6 f4"><Image src="/image/fi_7491804.svg" className="pa3" style={{ filter: "brightness(95%)" }} />{translate("Schnelle Lieferung")}</div>
                      </div>
                    </tr>
                    <tr>
                      <div className={"w-100 flex flex-row items-center justify-center"}>
                      <div className="flex flex-row items-center justify-center black-60 fw6 f4"><Image src="/image/fi_4947209.svg" className="pa3" style={{ filter: "brightness(95%)" }} />{translate("Exklusive Rabatte möglich")}</div>
                      </div>
                    </tr>
                  </tbody>
                </Table>
              </Responsive>
            </section> */}

            <section className="container pb4 pt2">
                
                <Responsive minWidth={1200}>
                  <p className="f2 fw7 pt2">{translate("Topseller")}</p>
                {<ProductList
                count={4}
                start={0}
                list={productsForList}
                displayMode={"cards"}
                repeat={ProductCard} />}
                </Responsive>
                <Responsive maxWidth={1199} minWidth={900}>
                  <p className="pl3 pr3 f2 fw7 pt2">{translate("Topseller")}</p>
                {<ProductList
                count={4}
                start={0}
                list={productsForList}
                displayMode={"tablet"}
                repeat={ProductCard} />}
                </Responsive>
                <Responsive maxWidth={899}>
                  <div className="flex flex-column items-center">
                  <p className="pl3 pr3 f2 fw7 pt2">{translate("Topseller")}</p>
                {<div className="pl5 pr5 tc flex flex-column items-center justify-center"><ProductList
                count={4}
                start={0}
                list={productsForList}
                displayMode={"mobile"}
                repeat={ProductCard} /></div>}
                </div>
                </Responsive>
            </section>
            <section id="wrapperContact container">

              <div className="sectionCategory">

                {/* Inhalt */}
                <div className="contentArea">
                <CategorySlider 
                firstCategory={categoryforCards1} orderMode={orderMode} style={{zIndex: "9999"}} />
                <div className="container pt5">
                  {/*                <Button 
                  style={{
                  borderRadius: "35px", 
                  height: "60px", 
                  width: "250px", 
                  backgroundColor: "transparent", 
                  border: "2px solid white", 
                  color: "white",
                  transition: "all 0.3s ease"
                  }} 
                  className="fw5 ml3 pl3"
                  onMouseEnter={(e) => {
                  e.target.style.backgroundColor = "#a2cf66";
                  e.target.style.color = "white";
                  e.target.style.border = "2px solid #a2cf66";
                  }}
                  onMouseLeave={(e) => {
                  e.target.style.backgroundColor = "transparent";
                  e.target.style.color = "white";
                  e.target.style.border = "2px solid white";
                  }}
                onClick={() => this.props.history.push("/collection/40/")}
                 >
                  {translate("Alle Produkte")}
                </Button> */}
                </div>
                </div>
              </div>
              </section>
            {/*<section id="wrapperContact container">

              <div className="sectionCategory">

                <div className="contentArea">
                <CategorySlider 
                firstCategory={categoryforCards1} orderMode={orderMode} style={{zIndex: "9999"}} />
                <div className="container pt5">
                </div>
                </div>
              </div>
              </section> */}
            {/*            <section className="container pb4 pt4">
                
                <Responsive minWidth={768}>
                  <p className="f4 fw7">{translate("Topseller")}</p>
                {<ProductList
                count={4}
                start={0}
                list={productsForList}
                displayMode={"mobile"}
                repeat={ProductCard} />}
                </Responsive>
                <Responsive maxWidth={767}>
                  <p className="pr3 pl3 f4 fw7">{translate("Topseller")}</p>
                {<div className="pl5 pr5"><ProductList
                count={4}
                start={0}
                list={productsForList}
                displayMode={"mobile"}
                repeat={ProductCard} /></div>}
                </Responsive>
            </section> */}
            <section>
              <Responsive minWidth={768} maxWidth={1199}>
              <div className="flex flex-row justify-between">
                <div>
                  <div className="pl2 pr2 tc" style={{ textAlign: "left"}}>
                <p className="f5 fw7 black-30">{translate("Unternehmen")}</p>
                <p className="f3 fw7">{translate(`Trendsoft`)}<br/>{translate(`Die Experten für`)}<br/>{translate(`Digitalisierung`)}</p>
                <p className="f1 fw7"></p>
                <p className="f1 fw7"></p>
                <p className="f5 fw5">
                  {translate("Seit über 75 Jahren vertreiben wir Verbrauchsartikel für")}<br/>
                  {translate("Krankenhäuser, Laborbedarf und Mikrobiologie Zubehör –")}<br/>
                  {translate("weltweiter Großhandel und Export, sowie eigene")}<br/>
                  {translate("Produktionen machen unser Geschäft spannend und")}<br/>
                  {translate("vielfältig. Wir sind ein Familienunternehmen – traditionell mit")}<br/>
                  {translate("Mut und Trend zur stetigen Weiterentwicklung und Flexibilität")}<br/>
                  {translate("am Markt- mit Firmensitz in Lingen.")}<br/>
                </p>
                <p className="f5 fw5">
                  {translate("Heute beliefert die Trendsoft Medizinalbedarf GmbH")}<br/>
                  {translate("Kliniken und Labore in über 110 Länder und hat sich mit")} <br/>
                  {translate("zahlreichen Patenten und Schutzmarken weltweit einen")} <br/>
                  {translate("Namen gemacht.")}
                </p>
                <p>
                <Button primary style={{
                  borderRadius: "35px", 
                  height: "60px", 
                  width: "250px", 
                  color: "white",
                  transition: "all 0.3s ease",
                  padding: "10px 20px 10px 20px",
                }} 
                className="ml3 pl3 mr2"
                as={"a"} href="//herenz.de/unternehmen_medizinalbedarf/"
                 >
                  <p className="pt2 f4 fw5">{translate("Mehr erfahren")}</p>
                </Button>
                </p>
                </div></div>
                <div>
                  <div className="flex flex-row items-end justify-end">
                  <Image src={currentLanguage === "de" ? "/image/Left.png" : "/image/Left_EN.png"} className="" style={{ maxWidth: "230px", height: "230px" }} />
                  <Image src="/image/globus.png" className="" style={{ maxWidth: "230px", height: "230px" }} />
                  </div>
                  <div className="flex flex-row items-end justify-end" >
                  <Image src="/image/abtupf.png" className="" style={{ maxWidth: "230px", height: "230px" }} />
                  <Image src={currentLanguage === "de" ? "/image/Right.png" : "/image/Right_EN.png"} className="" style={{ maxWidth: "230px", height: "230px" }} />
                  </div></div>
                </div>
                </Responsive>
              <Responsive minWidth={1200}>
                <Table className="tableUeberUns">
              <colgroup>
              <col style={{ width: "40%" }} />
              <col style={{ width: "40%" }} />
              </colgroup>
              <tbody>
              <tr>
                <td className="pl5 tc">
                <div className="container tc" style={{ textAlign: "left", paddingLeft: "15rem" }}>
                <p className="f4 fw7 black-30">{translate("Unternehmen")}</p>
                <p className="f1 fw7">{translate(`Trendsoft`)}<br/>{translate(`Die Experten für`)}<br/>{translate(`Digitalisierung`)}</p>
                <p className="f1 fw7"></p>
                <p className="f1 fw7"></p>
                <p className="f4 fw5">
                  {translate("Seit über 75 Jahren vertreiben wir Verbrauchsartikel für")}<br/>
                  {translate("Krankenhäuser, Laborbedarf und Mikrobiologie Zubehör –")}<br/>
                  {translate("weltweiter Großhandel und Export, sowie eigene")}<br/>
                  {translate("Produktionen machen unser Geschäft spannend und")}<br/>
                  {translate("vielfältig. Wir sind ein Familienunternehmen – traditionell mit")}<br/>
                  {translate("Mut und Trend zur stetigen Weiterentwicklung und Flexibilität")}<br/>
                  {translate("am Markt- mit Firmensitz in Hamburg.")}<br/>
                </p>
                <p className="f4 fw5">
                  {translate("Heute beliefert die Trendsoft Medizinalbedarf GmbH")}<br/>
                  {translate("Kliniken und Labore in über 110 Länder und hat sich mit")} <br/>
                  {translate("zahlreichen Patenten und Schutzmarken weltweit einen")} <br/>
                  {translate("Namen gemacht.")}
                </p>
                <p>
                <Button primary style={{
                  borderRadius: "35px", 
                  height: "60px", 
                  width: "250px", 
                  color: "white",
                  transition: "all 0.3s ease",
                  padding: "10px 20px 10px 20px",
                }} 
                className="ml3 pl3 mr2"
                as={"a"} href="//herenz.de/unternehmen_medizinalbedarf/"
                 >
                  <p className="pt2 f4 fw5">{translate("Mehr erfahren")}</p>
                </Button>
                </p>
                </div>
                </td>
                <td>
                <div className="flex flex-row items-end justify-end">
                  <Image src={currentLanguage === "de" ? "/image/Left.png" : "/image/Left_EN.png"} className="" style={{ maxWidth: "100%", height: "auto" }} />
                  <Image src="/image/globus.png" className="" style={{ maxWidth: "100%", height: "auto" }} />
                  </div>
                  <div className="flex flex-row items-end justify-end" >
                  <Image src="/image/abtupf.png" className="" style={{ maxWidth: "100%", height: "auto" }} />
                  <Image src={currentLanguage === "de" ? "/image/Right.png" : "/image/Right_EN.png"} className="" style={{ maxWidth: "100%", height: "auto" }} />
                  </div>
                </td>
              </tr>
              </tbody>
                </Table>
              </Responsive>
              <Responsive maxWidth={767}>
              <div className="container tc pa3" style={{ textAlign: "left",}}>
                <p className="f4 fw7 black-30 pl3 pr3">{translate("Unternehmen")}</p>
                <p className="f3 fw7 pl3 pr3">{translate(`Trendsoft:`)}<br/>{translate(`Die Experten für Digitalisierung`)}</p>
                <p className="f5 fw5 pa3 ">
                  {translate("Seit über 75 Jahren vertreiben wir Verbrauchsartikel für")}<br/>
                  {translate("Krankenhäuser, Laborbedarf und Mikrobiologie Zubehör –")}<br/>
                  {translate("weltweiter Großhandel und Export, sowie eigene")}<br/>
                  {translate("Produktionen machen unser Geschäft spannend und")}<br/>
                  {translate("vielfältig. Wir sind ein Familienunternehmen – traditionell mit")}<br/>
                  {translate("Mut und Trend zur stetigen Weiterentwicklung und Flexibilität")}<br/>
                  {translate("am Markt- mit Firmensitz in Hamburg.")}<br/>
                </p>
                <p className="f5 fw5 pl3 pr3">
                  {translate("Heute beliefert die Trendsoft Medizinalbedarf GmbH")}<br/>
                  {translate("Kliniken und Labore in über 110 Länder und hat sich mit")} <br/>
                  {translate("zahlreichen Patenten und Schutzmarken weltweit einen")} <br/>
                  {translate("Namen gemacht.")}
                </p>
                <p className="pa3">
                <Button primary style={{
                  borderRadius: "35px", 
                  height: "60px", 
                  width: "250px", 
                  color: "white",
                  transition: "all 0.3s ease",
                  padding: "10px 20px 10px 20px",
                }} 
                className="ml3 pl3 mr2"
                  as={"a"} href="//herenz.de/unternehmen_medizinalbedarf/"
                 >
                  <p className="pt2 f4 fw5">{translate("Mehr erfahren")}</p>
                </Button>
                </p>
                </div>
                 <div className="flex flex-row items-center justify-center">
                  <Image src={currentLanguage === "de" ? "/image/Left.png" : "/image/Left_EN.png"} className="" style={{ maxWidth: "300px", minWidth: "220px", height: "auto" }} />
                  <Image src="/image/globus.png" className="" style={{ maxWidth: "300px", minWidth: "220px", height: "auto" }} />
                  </div>
                  <div className="flex flex-row items-center justify-center" >
                  <Image src="/image/abtupf.png" className="" style={{ maxWidth: "300px", minWidth: "220px", height: "auto" }} />
                  <Image src={currentLanguage === "de" ? "/image/Right.png" : "/image/Right_EN.png"} className="" style={{ maxWidth: "300px", minWidth: "220px", height: "auto" }} />
                  </div>
              </Responsive>

            </section>
            <section id="wrapperContact">
            <div className="sectionContact">  
              {/*<div className="flex flex-column items-center justify-center pt5 pb5"> 
                <div className="pa3">
                  <p className="tc f3 fw7 white">{translate("Vertriebsinnendienst")}</p>
                </div>
                <div className="pa3">
                  <a href={`tel:+49407392040`}><span className="f5 fw5" style={{ color: "#a2cf66", backgroundColor: "transparent" }}><Icon
                    name={"phone"} />+49-40-739204-0 </span></a>
                </div>
                <div className="pa3">
                  <Button 
                    style={{
                    borderRadius: "35px", 
                    height: "60px", 
                    width: "250px", 
                    backgroundColor: "transparent", 
                    border: "2px solid white", 
                    color: "white",
                    transition: "all 0.3s ease",
                    paddingTop: "20px",
                    alignItems: "center", 
                    justifyContent: "center",
                    }} 
                    className="fw5 ml3 pl3"
                    onMouseEnter={(e) => {
                    e.target.style.backgroundColor = "#a2cf66";
                    e.target.style.color = "white";
                    e.target.style.border = "2px solid #a2cf66";
                    }}
                    onMouseLeave={(e) => {
                    e.target.style.backgroundColor = "transparent";
                    e.target.style.color = "white";
                    e.target.style.border = "2px solid white";
                    }}
                    href={`mailto:shop@herenz.de?subject=Anfrage an den Vertrieb, Kunde #${shop.session ? shop.session.value.map_id : ''}`}>
                    {translate("Email an den Vertrieb")}
                  </Button>
                </div>
                </div>*/}
               <div className="flex flex-column items-center justify-center pt5 pb5"> 
                <div className="pa3">
                  <p className="tc f4 fw5 white">{translate("Newsletteranmeldung")}</p>
                  <p className="tc f2 fw7 white">{translate("Neues entdecken.")}<br/>{translate("Informiert bleiben.")} </p>
                  <p className="tc f5 fw4 white">{translate("Immer einen Schritt voraus – mit unseren Produktnews:")}</p>
                </div>
                <div className="pa3">
              <Link to={shop.session ? "/account/?referer=_newsletter" : "/login"}><Button 
                style={{ minWidth: "280px", height: "50px", borderRadius: "35px" }} primary>{translate("Anmeldung absenden")}</Button></Link>
                </div>
                </div>
                {/*              <Responsive minWidth={768}>
              <div className="container pt5 pb5">
              <Table style={{ backgroundColor: "transparent" }}>
              <colgroup>
              <col style={{ width: "33%" }} />
              <col style={{ width: "33%" }} />
              <col style={{ width: "33%" }} />
              </colgroup>
              <tbody>
              <tr>
                <td className="relative pa3 tc">
                  <p className="tc f3 fw7 white">{translate("Purchase")}</p>
                </td>
                <td className="relative pa3 tc">
                  <p className="tc f3 fw7 white">{translate("Vertriebsinnendienst")}</p>
                </td>
                <td className="relative pa3 tc" style={{ textAlign: "right" }}>
                  <p className="tc f3 fw7 white">{translate("Export")}</p>
                </td>
              </tr>

              <tr>
                <td className="relative pa3 tc" style={{ textAlign: "center" }}>
                <a href={`tel:+49407392040`}><span className="f5 fw5" style={{ color: "#a2cf66", backgroundColor: "transparent" }}><Icon
            name={"phone"} />+49-40-739204-0 </span></a>
                </td>
                <td className="relative pa3 tc" style={{ textAlign: "center" }}>
                <a href={`tel:+49407392040`}><span className="f5 fw5" style={{ color: "#a2cf66", backgroundColor: "transparent" }}><Icon
            name={"phone"} />+49-40-739204-0 </span></a>
                </td>
                <td className="relative pa3 tc" style={{ textAlign: "center" }}>
                <a href={`tel:+49407392040`}><span className="f5 fw5" style={{ color: "#a2cf66", backgroundColor: "transparent" }}><Icon
            name={"phone"} />+49-40-739204-0 </span></a>
                </td>
              </tr>
              <tr>
                <td className="relative pa3 tc" style={{ textAlign: "center" }}>
                <Button 
            style={{
            borderRadius: "35px", 
            height: "60px", 
            width: "250px", 
            backgroundColor: "transparent", 
            border: "2px solid white", 
            color: "white",
            transition: "all 0.3s ease",
            paddingTop: "20px",
            alignItems: "center", 
            justifyContent: "center",
            }} 
            className="fw5 ml3 pl3"
            onMouseEnter={(e) => {
            e.target.style.backgroundColor = "#a2cf66";
            e.target.style.color = "white";
            e.target.style.border = "2px solid #a2cf66";
            }}
            onMouseLeave={(e) => {
            e.target.style.backgroundColor = "transparent";
            e.target.style.color = "white";
            e.target.style.border = "2px solid white";
            }}
            href={`mailto:Einkauf@herenz.de?subject=Anfrage an den Einkauf, Kunde #${shop.session.value.map_id}`}>
            {translate("Email an den Einkauf")}
            </Button>
                    </td>
                    <td className="relative pa3 tc" style={{textAlign: "center"}}>
                    <Button 
            style={{
            borderRadius: "35px", 
            height: "60px", 
            width: "250px", 
            backgroundColor: "transparent", 
            border: "2px solid white", 
            color: "white",
            transition: "all 0.3s ease",
            paddingTop: "20px",
            alignItems: "center", 
            justifyContent: "center",
            }} 
            className="fw5 ml3 pl3"
            onMouseEnter={(e) => {
            e.target.style.backgroundColor = "#a2cf66";
            e.target.style.color = "white";
            e.target.style.border = "2px solid #a2cf66";
            }}
            onMouseLeave={(e) => {
            e.target.style.backgroundColor = "transparent";
            e.target.style.color = "white";
            e.target.style.border = "2px solid white";
            }}
            href={`mailto:Verkauf@herenz.de?subject=Anfrage an den Vertrieb, Kunde #${shop.session.value.map_id}`}>
            {translate("Email an den Vertrieb")}
            </Button>
                    </td>
                    <td className="relative pa3 tc" style={{textAlign: "center"}}>
                    <Button 
            style={{
            borderRadius: "35px", 
            height: "60px", 
            width: "250px", 
            backgroundColor: "transparent", 
            border: "2px solid white", 
            color: "white",
            transition: "all 0.3s ease",
            paddingTop: "20px",
            alignItems: "center", 
            justifyContent: "center",
            }} 
            className="fw5 ml3 pl3"
            onMouseEnter={(e) => {
            e.target.style.backgroundColor = "#a2cf66";
            e.target.style.color = "white";
            e.target.style.border = "2px solid #a2cf66";
            }}
            onMouseLeave={(e) => {
            e.target.style.backgroundColor = "transparent";
            e.target.style.color = "white";
            e.target.style.border = "2px solid white";
            }}
            href={`mailto:Export@herenz.de?subject=Anfrage an den Export, Kunde #${shop.session.value.map_id}`}>
            {translate("Email an den Export")}
            </Button>
                    </td>
                </tr>
                </tbody>
            </Table>
                </div> 
                </Responsive>
                <Responsive maxWidth={767}>
                <div className="container pt5 pb5">
              <Table style={{ backgroundColor: "transparent" }}>
              <tbody>
              <tr>
                <td className="relative pa3 tc" style={{ textAlign: "center" }}>
                  <p className="tc f3 fw7 white">{translate("Purchase")}</p>
                  <p><a href={`tel:+49407392040`}><span className="f5 fw5" style={{ color: "#a2cf66", backgroundColor: "transparent" }}><Icon
            name={"phone"} />+49-40-739204-0 </span></a></p>
                            <p><Button 
            style={{
            borderRadius: "35px", 
            height: "60px", 
            width: "250px", 
            backgroundColor: "transparent", 
            border: "2px solid white", 
            color: "white",
            transition: "all 0.3s ease",
            paddingTop: "20px",
            alignItems: "center", 
            justifyContent: "center",
            }} 
            className="fw5 ml3 pl3"
            onMouseEnter={(e) => {
            e.target.style.backgroundColor = "#a2cf66";
            e.target.style.color = "white";
            e.target.style.border = "2px solid #a2cf66";
            }}
            onMouseLeave={(e) => {
            e.target.style.backgroundColor = "transparent";
            e.target.style.color = "white";
            e.target.style.border = "2px solid white";
            }}
            href={`mailto:Einkauf@herenz.de?subject=Anfrage an den Einkauf, Kunde #${shop.session.value.map_id}`}>
            {translate("Email an den Einkauf")}
            </Button></p>
                </td>
                </tr>
                <tr>
                <td className="relative pa3 tc" style={{ textAlign: "center" }}>
                  <p className="tc f3 fw7 white">{translate("Sales")}</p>
                  <p><a href={`tel:+49407392040`}><span className="f5 fw5" style={{ color: "#a2cf66", backgroundColor: "transparent" }}><Icon
            name={"phone"} />+49-40-739204-0 </span></a></p>
                                <p><Button 
            style={{
            borderRadius: "35px", 
            height: "60px", 
            width: "250px", 
            backgroundColor: "transparent", 
            border: "2px solid white", 
            color: "white",
            transition: "all 0.3s ease",
            paddingTop: "20px",
            alignItems: "center", 
            justifyContent: "center",
            }} 
            className="fw5 ml3 pl3"
            onMouseEnter={(e) => {
            e.target.style.backgroundColor = "#a2cf66";
            e.target.style.color = "white";
            e.target.style.border = "2px solid #a2cf66";
            }}
            onMouseLeave={(e) => {
            e.target.style.backgroundColor = "transparent";
            e.target.style.color = "white";
            e.target.style.border = "2px solid white";
            }}
            href={`mailto:Verkauf@herenz.de?subject=Anfrage an den Vertrieb, Kunde #${shop.session.value.map_id}`}>
            {translate("Email an den Vertrieb")}
            </Button></p>
                </td>
                </tr>
                <tr>
                <td className="relative pa3 tc" style={{ textAlign: "center" }}>
                  <p className="tc f3 fw7 white">{translate("Export")}</p>
                  <p><a href={`tel:+49407392040`}><span className="f5 fw5" style={{ color: "#a2cf66", backgroundColor: "transparent" }}><Icon
            name={"phone"} />+49-40-739204-0 </span></a></p>
                                <p><Button 
            style={{
            borderRadius: "35px", 
            height: "60px", 
            width: "250px", 
            backgroundColor: "transparent", 
            border: "2px solid white", 
            color: "white",
            transition: "all 0.3s ease",
            paddingTop: "20px",
            alignItems: "center", 
            justifyContent: "center",
            }} 
            className="fw5 ml3 pl3"
            onMouseEnter={(e) => {
            e.target.style.backgroundColor = "#a2cf66";
            e.target.style.color = "white";
            e.target.style.border = "2px solid #a2cf66";
            }}
            onMouseLeave={(e) => {
            e.target.style.backgroundColor = "transparent";
            e.target.style.color = "white";
            e.target.style.border = "2px solid white";
            }}
            href={`mailto:Export@herenz.de?subject=Anfrage an den Export, Kunde #${shop.session.value.map_id}`}>
            {translate("Email an den Export")}
            </Button></p>
                </td>
              </tr>
                </tbody>
            </Table>
                </div> 
                  </Responsive> */}
              </div>
            </section>
            </div>
        )
    }
}




// WEBPACK FOOTER //
// ./src/theme/demo2025/pages/HomePageV2.js